import { MGPMap } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
export class SquarzMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const player = node.gameState.getCurrentPlayer();
        const jumps = [];
        const duplicationMap = new MGPMap();
        for (const coordAndContent of node.gameState.getCoordsAndContents()) {
            if (coordAndContent.content.equals(player)) {
                const coordMoves = this.rules.getPossiblesMoves(node.gameState, coordAndContent.coord, config);
                const coordJumps = [];
                const coordDuplications = [];
                coordMoves.forEach((m) => {
                    if (m.isDuplication())
                        coordDuplications.push(m);
                    else
                        coordJumps.push(m);
                });
                jumps.push(...coordJumps);
                for (const duplication of coordDuplications) {
                    // The aim of this is to only have one duplication by landing square
                    duplicationMap.put(duplication.getEnd(), duplication);
                }
            }
        }
        const duplications = duplicationMap.getValueList();
        return jumps.concat(duplications);
    }
}
